<template>
  <div class="viimg">
    <img
      :src="imgurl"
      class="preview"
    />
    <div class="bofang center">
      <svg-icon icon-class="linear-play"  class="svgimg"/>
    </div>
    <div class="media_time" v-if="istime">01:10</div>
  </div>
</template>

<script>
export default {
    props:{
        istime:{
            type:Boolean,
            default:false
        },
        imgurl:String
    }
};
</script>

<style lang="scss" scoped>
.viimg {
  position: relative;
  
    width: 100%;
    height: 100%;
  &:hover {
    .bofang {
      height: 100%;
    }
  }
  .preview {
    width: 100%;
    height: 100%;
  }
  .bofang {
    overflow: hidden;
    transition: all 0.3s;
    height: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba($color: #000000, $alpha: 0.3);

    .svgimg{
      border-radius: 50%;
      color: #A2A2A2;
      font-size: 40px;
    }
  }
  .media_time {
    color: #fff;
    font-size: 12px;
    position: absolute;
    bottom: 6%;
    right: 6%;
    padding: 0 14px;
    height: 24px;
    line-height: 24px;
    background: rgba($color: #000, $alpha: 0.3);
    border-radius: 50px;
  }
}
</style>